import { registerComponent } from '@gig/magic-common';
import PeekPasswordComponent from './peek-password.vue.js';
export { default as PeekPasswordComponent } from './peek-password.vue.js';

var PeekPassword = registerComponent(PeekPasswordComponent);

export { PeekPassword };
